import { Upload, Modal, message, Typography } from "antd";
import type { UploadFile, UploadProps } from "antd/es/upload/interface";
import { UploadOutlined } from "@ant-design/icons";
import { useState } from "react";

const { Text } = Typography;

interface ImageUploadProps {
  value?: UploadFile | null;
  onChange?: (file: UploadFile | null) => void;
  disabled?: boolean;
}

const ImageUpload: React.FC<ImageUploadProps> = ({
  value,
  onChange,
  disabled,
}) => {
  const [fileList, setFileList] = useState<UploadFile[]>(value ? [value] : []);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState<string>("");

  const beforeUpload: UploadProps["beforeUpload"] = (file) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      message.error("Only image files are allowed");
      return Upload.LIST_IGNORE;
    }

    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      message.error("Image must be smaller than 5MB");
      return Upload.LIST_IGNORE;
    }

    return false; // prevent auto upload
  };

  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview && file.originFileObj) {
      file.preview = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj as Blob);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = reject;
      });
    }

    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
  };

  const handleChange: UploadProps["onChange"] = async ({
    fileList: newList,
  }) => {
    setFileList(newList);
    onChange?.(newList[0] || null);
    if (newList && newList[0] && newList[0]?.originFileObj) {
      //  await handleFile(newList[0].originFileObj as File);
    }
  };

  const handleRemove = () => {
    setFileList([]);
    onChange?.(null);
  };

  return (
    <>
      <Upload
        listType="picture-card"
        maxCount={1}
        fileList={fileList}
        beforeUpload={beforeUpload}
        onPreview={handlePreview}
        onChange={handleChange}
        onRemove={handleRemove}
        disabled={disabled}
      >
        {fileList.length >= 1 ? null : (
          <div
            style={{
              width: 220,
              height: 220,
              borderRadius: 12,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
          >
            <UploadOutlined style={{ fontSize: 42 }} />
            <Text style={{ marginTop: 12 }}>Click to upload image</Text>
            <Text type="secondary">Max size 10MB</Text>
          </div>
        )}
      </Upload>

      <Modal
        open={previewOpen}
        footer={null}
        onCancel={() => setPreviewOpen(false)}
        width="100vw"
        style={{ top: 0 }}
        bodyStyle={{
          padding: 0,
          background: "#000",
          height: "100vh",
        }}
      >
        <img
          alt="preview"
          src={previewImage}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </Modal>
    </>
  );
};

export default ImageUpload;
